import { specialistService } from "../_services";
import moment from 'moment'
moment.locale('ru')

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    updating: false,
    apps: {
        list: [],
        status: status.INITIAL
    },
    judges: {
        list: [],
        status: status.INITIAL
    },
    statuses: {
      list: [],
      status: status.INITIAL
    },
    advocatEventTypes: {
      list: [],
      status: status.INITIAL
    },
    boostingKfs: {
      list: [],
      status: status.INITIAL
    },
    selectedStatus: null,
    selectedJudge: null,

    period: null,

    advocatApp: null
  },
  getters: {
    statuses: ({ statuses }) => statuses.list,
    isStatusesLoaded: ({ statuses }) => statuses.status == status.LOADED,

    advocatEventTypes: ({ advocatEventTypes }) => advocatEventTypes.list,
    isAdvocatEventTypesLoaded: ({ advocatEventTypes }) => advocatEventTypes.status == status.LOADED,

    boostingKfs: ({ boostingKfs }) => boostingKfs.list,
    isBoostingKfsLoaded: ({ boostingKfs }) => boostingKfs.status == status.LOADED,

    apps: ({ apps }) => apps.list,
    isAppsLoaded: ({ apps }) => apps.status == status.LOADED,

    judges: ({ judges }) => judges.list,
    isJudgesLoaded: ({ judges }) => judges.status == status.LOADED,

    advocatApp: ({ advocatApp }) => advocatApp,
    isAppLoaded: ({ advocatApp }) => advocatApp != null,
  },
  mutations: {
    setUpdating: (state, value) => {
      state.updating = value
    },
    setAdvocatApp: (state, payload) => {
      state.advocatApp = payload
    },
    addAdvocatApp: (state, advocatApp) => {
      state.apps.list.push(advocatApp)
    },
    deleteAdvocatApp: (state, advocatAppId) => {
      state.advocatApp = null
      let index = state.apps.list.findIndex(item => item.id === advocatAppId)
      state.apps.list.splice(index, 1)
    },
    deleteAdvocatAppItem: (state, advocatAppItemId) => {
      let index = state.advocatApp.advocatAppItems.findIndex(item => item.id === advocatAppItemId)
      state.advocatApp.summa-=state.advocatApp.advocatAppItems[index].tariff
      state.advocatApp.advocatAppItems.splice(index, 1)
    },
    addAdvocatAppItem: (state, advocatAppItem) => {
      if(state.advocatApp!=null) { 
        state.advocatApp.advocatAppItems.push(advocatAppItem)
        state.advocatApp.summa+=advocatAppItem.tariff
      }
    },
    editAdvocatAppItem: (state, advocatAppItem) => {
      if(state.advocatApp!=null) { 
        let curr = state.advocatApp.advocatAppItems.filter(item => item.id == advocatAppItem.id)[0]
        state.advocatApp.summa+=advocatAppItem.tariff-curr.tariff
        Object.assign(curr, advocatAppItem)
      }
    },
    setApps: ({ apps }, payload) => {
      apps.list = payload
    },
    setAppsStatus: ({ apps }, status) => {
      apps.status = status
    },

    setJudges: ({ judges }, payload) => {
      judges.list = payload
    },
    setJudgesStatus: ({ judges }, status) => {
      judges.status = status
    },
    selectJudge: (state, payload) => {
      state.selectedJudge = payload
    },

    setStatuses: ({ statuses }, payload) => {
      statuses.list = payload
    },
    setStatusesStatus: ({ statuses }, status) => {
      statuses.status = status
    },
    selectStatus: (state, payload) => {
      state.selectedStatus = payload
    },

    setAdvocatEventTypes: ({ advocatEventTypes }, payload) => {
      advocatEventTypes.list = payload
    },
    setAdvocatEventTypesStatus: ({ advocatEventTypes }, status) => {
      advocatEventTypes.status = status
    },

    setBoostingKfs: ({ boostingKfs }, payload) => {
      boostingKfs.list = payload
    },
    setBoostingKfsStatus: ({ boostingKfs }, status) => {
      boostingKfs.status = status
    },

    setPeriod: (state, payload) => {
      state.period = payload
    }
  },
  actions: {
    INIT: ({ dispatch }) => {
        dispatch('GET_STATUSES')
        dispatch('LOAD_APPS')
    },
    INIT_ITEM: ({ dispatch }, { appId }) => {
        dispatch('GET_STATUSES')
        dispatch('GET_TYPES')
        dispatch('GET_KFS')
        dispatch('LOAD_APP', { appId })
    },
    GET_STATUSES: ({ state, commit }) => {
        if(state.statuses.status == status.INITIAL ){
           commit('setStatusesStatus', status.LOADING)
           specialistService.appStatuses().then(data => {
             commit('setStatuses', data)
             commit('setStatusesStatus', status.LOADED)
             commit('selectStatus', data.filter(item => item.name === "REJECT")[0])
           })
        }
    },
    GET_TYPES: ({ state, commit }) => {
        if(state.advocatEventTypes.status == status.INITIAL ){
           commit('setAdvocatEventTypesStatus', status.LOADING)
           specialistService.advocatEventTypes().then(data => {
             commit('setAdvocatEventTypes', data)
             commit('setAdvocatEventTypesStatus', status.LOADED)
           })
        }
    },
    GET_KFS: ({ state, commit }) => {
        if(state.boostingKfs.status == status.INITIAL ){
           commit('setBoostingKfsStatus', status.LOADING)
           specialistService.boostingKfs().then(data => {
             commit('setBoostingKfs', data)
             commit('setBoostingKfsStatus', status.LOADED)
           })
        }
    },
    LOAD_APPS: ({ state, commit }) => {
        if(state.apps.status == status.INITIAL ){
           commit('setAppsStatus', status.LOADING)
           commit('setJudgesStatus', status.LOADING)
           specialistService.advocatApps().then(data => {
               commit('setApps', data)
               commit('setAppsStatus', status.LOADED)

               let judgeList=[] 
               data.forEach(d => {
                 judgeList.find(j => j.id === d.courtCase.judge.id) ? null : judgeList.push(d.courtCase.judge)
               })

               commit('setJudges', judgeList)
               commit('setJudgesStatus', status.LOADED)
           })
        }
    },
    LOAD_APP: ({ state, commit }, { appId }) => {
        if (state.advocatApp!=null && state.advocatApp.id != appId) {
          commit('setAdvocatApp', null)
        }
        specialistService.advocatApp(appId)
        .then(data => {
          commit('setAdvocatApp', data)
        })
    },
    CREATE_APP: ({ commit }, payload) => {
        commit('setUpdating', true)
        return specialistService.advocatAppCreate( payload )
               .then(data => {
                  commit('addAdvocatApp', data)
                  commit('setUpdating', false)
                  return data
               })
    },
    CREATE_APP_ITEM: ({ state, commit }, payload) => {
        if (state.advocatApp!=null) {
          specialistService.advocatAppItemCreate( state.advocatApp.id, payload ).then(data => {
              commit('addAdvocatAppItem', data)
              commit('setAppsStatus', status.INITIAL)
          })
        }
    },
    UPDATE_APP_ITEM: ({ commit }, payload) => {
        specialistService.advocatAppItemUpdate( payload ).then(data => {
            commit('setAdvocatApp', data)
            commit('setAppsStatus', status.INITIAL)
        })
    },

    DELETE_APP_ITEM: ({ commit }, { appItemId }) => {
        specialistService.advocatAppItemDelete( appItemId ).then(() => {
            commit('deleteAdvocatAppItem', appItemId)
            commit('setAppsStatus', status.INITIAL)
        })
    },

    SEND_APP: ({ commit }, { appId }) => {
        specialistService.advocatAppSend( appId ).then(data => {
            commit('setAdvocatApp', data)
            commit('setAppsStatus', status.INITIAL)
        })
    },

    DELETE_APP: ({ commit }, { appId }) => {
        return specialistService.advocatAppDelete( appId ).then(data => {
            commit('deleteAdvocatApp', appId)
            return data
        })
    },
    refresh: (context, { appId }) => {
        return  specialistService.advocatApp(appId)
        .then(data => {
            return data
        })
    },
    reset: ({ commit }, { app }) => {
        commit('setAdvocatApp', app)
    },
  }
}